export default function () {
  const widgetName = 'hashtagTitle';
  const widgetOpts = hashtagTitleOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: ''
    },
    cardWidgetLoaded: function (data, owl, hasData) {


      function customWidget() {
        $(`#${widgetName} .card-widget-item`).each(function (i) {
          $(this).find('.buttonwrap').remove();
          $(this).append(`<span class="instafeedTitle">@pdxrosefestival<img src="${FULLCLIENTTHEMEPATH}/images/instagram-logo.png" alt="Instagram Logo">${data.items[0].Title}</span>`);
          $(this).find('.card-content').remove();
        })
      }

      customWidget()



    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: ''
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false,
    textOverImage: true
  });
}